var machines = document.querySelectorAll('.mask__item');

// Function to update checked state
function updateCheckedStates() {
  machines.forEach((item) => {
    const isChecked = item.control && item.control.checked;
    if (isChecked) {
      item.classList.add('checked-product');
    } else {
      item.classList.remove('checked-product');
    }
  });
}

// Handle mask item clicks
machines.forEach((item) => {
  item.addEventListener('click', () => {
    updateCheckedStates();
  });

  // Handle "Select this mask" span clicks
  const selectTrigger = item.querySelector('.select-mask-trigger');
  if (selectTrigger) {
    selectTrigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const maskRadio = item.control;
      if (maskRadio) {
        maskRadio.checked = true;
        updateCheckedStates();
      }
    });
  }

  // Handle variant option clicks within the mask item
  const variantInputs = item.querySelectorAll('input[type="radio"][name*="option"]');
  variantInputs.forEach((variantInput) => {
    variantInput.addEventListener('change', (e) => {
      // When variant is changed, ensure the mask itself is selected
      const maskRadio = item.control;
      if (maskRadio && !maskRadio.checked) {
        maskRadio.checked = true;
        updateCheckedStates();
      }
    });

    // Also handle clicks on variant inputs to ensure mask is selected
    variantInput.addEventListener('click', (e) => {
      const maskRadio = item.control;
      if (maskRadio && !maskRadio.checked) {
        maskRadio.checked = true;
        updateCheckedStates();
      }
    });
  });
});
